import React from 'react'
import InstalllMain from '../components/InstalllMain'

function Intsall() {

  return (
    <>
      <InstalllMain  />
    </>
  )
}

export default Intsall